import React from "react";
import useReveal from "../hooks/useReveal";
import { ClipboardList, CalendarCheck, KeyRound, ArrowRight } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Anfrage stellen",
    desc: "Nutzen Sie das Terminformular oder rufen Sie uns direkt an. Sie beschreiben kurz das Anliegen, den Fahrzeugtyp und Ihren Wunschtermin.",
    cta: { label: "Jetzt anrufen", href: "tel:02131544154" },
  },
  {
    n: "02",
    icon: CalendarCheck,
    title: "Terminbestätigung",
    desc: "Wir prüfen die Werkstattauslastung und bestätigen Ihren Termin telefonisch oder per E-Mail — inklusive Kostenrahmen, wenn gewünscht.",
  },
  {
    n: "03",
    icon: KeyRound,
    title: "Reparatur & Übergabe",
    desc: "Ihr Fahrzeug wird von unseren Meistern fachgerecht betreut. Nach Abschluss rufen wir Sie an — Sie holen ab, alles transparent dokumentiert.",
  },
];

export default function Process() {
  const [ref, visible] = useReveal();
  return (
    <section
      id="ablauf"
      ref={ref}
      data-testid="process-section"
      className={`relative bg-black border-t border-zinc-900 transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-[11px] tracking-[0.4em] uppercase gold-text mb-4">
              — So läuft's
            </div>
            <h2
              data-testid="process-heading"
              className="font-display text-4xl md:text-6xl uppercase tracking-tight leading-[0.95] max-w-3xl"
            >
              In drei Schritten
              <br />
              <span className="gold-text">zum Werkstattermin.</span>
            </h2>
          </div>
          <p className="text-zinc-400 text-sm max-w-sm leading-relaxed">
            Kein Papierkram, kein Herumtelefonieren. Wir halten den Prozess
            bewusst einfach — so wie es sein sollte.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-zinc-900 border border-zinc-900">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="relative bg-[#0f0f12] p-8 md:p-10 min-h-[260px] flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <span className="w-12 h-12 gold-bg text-black grid place-items-center">
                    <Icon size={22} strokeWidth={2.25} />
                  </span>
                  <span className="font-display text-5xl md:text-6xl text-zinc-800 leading-none">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-display mt-6 text-2xl md:text-3xl uppercase tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                  {s.desc}
                </p>
                {s.cta && (
                  <a
                    href={s.cta.href}
                    data-testid={`process-cta-${s.n}`}
                    className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase gold-text border-b border-[#E0B33D]/40 hover:border-[#E0B33D] pb-0.5 self-start"
                  >
                    {s.cta.label} <ArrowRight size={14} />
                  </a>
                )}
                {i < steps.length - 1 && (
                  <span className="hidden md:block absolute top-10 right-[-14px] gold-text/70 z-10">
                    <ArrowRight size={24} />
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
